/**
 * @link https://js-toolkit.studiometa.dev/utils/keyCodes.html
 */
export const keyCodes = {
  ENTER: 13,
  SPACE: 32,
  TAB: 9,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
} as const;
